// src/helpers/resolveFromStore.js

import { store } from "../app/store"

let typeCache = {}
function resolveType(typeId){
    if (!typeId) return
    
    if (typeId.toLowerCase() in typeCache){
        return typeCache[typeId.toLowerCase()]?.['name']
    }
    const state = store ? store.getState() : {}
    
    const workspaceTypes = state.workspace.types
    typeCache = {...workspaceTypes}
    return typeCache[typeId.toLowerCase()]?.['name'] || typeId

    
}

const resolveFromStore = {
    "type" : resolveType
}
export default resolveFromStore
